import React from "react";
import "./About.css";
import AOS from "aos";
import "aos/dist/aos.css";
import { useEffect } from "react";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import Foot from "../Navbar-footer/Foot";
import Nav from "../Navbar-footer/Nav";

export default function Aboutus() {
  useEffect(() => {
    AOS.init({ duration: 1000 });
  }, []);

  const sliderSettings = {
    autoplay: true,
    dots: true,
    infinite: true,
    speed: 800,
    slidesToShow: 1,
    slidesToScroll: 1,
  };

  return (
    <>
     <Nav />
      <div className="aboutus-wrapper">
        {/* Header Section */}
        <section className="about">
          <div className="about-content">
            <div className="about-left">
              <h1 className="animate-slide-left">
                WE ARE SARV SAHAYATA SANGATHAN
              </h1>
              <p>
                SARV SAHAYATA SANGATHAN popularly known as SSS is a
                non-Governmental Organization (NGO) and a non-profit group of
                voluntary citizens, legally formed, organized, and operated at
                local and national levels. We are a development-driven team of
                socially aware individuals working to bring impactful change.
              </p>
            </div>
            <div className="about-right">
              <img src="../../assets/bloodlogo.png" alt="Blood donation" />
            </div>
          </div>
        </section>

        {/* Our Story */}
        <section className="our-story" data-aos="fade-up">
          <h2>Our Journey</h2>
          <p>
            Sarv Sahayata Sangathan (SSS) began with a powerful belief — that
            compassion, awareness, and collective action can transform society.
            From a small group of volunteers to a widespread network, we have
            grown by staying rooted in values of justice, inclusion, and human
            dignity.
          </p>
        </section>

        {/* Education Section */}
        <section className="section-grid" data-aos="fade-up">
          <h3>📚 Educational Empowerment</h3>
          <div className="grid-container">
            <div className="grid-item">
              <h4>Self-Reliance Campaigns</h4>
              <p>
                We educate youth about micro-industries and vocational skills
                that lead to employment, empowering them to become self-reliant.
              </p>
            </div>
            <div className="grid-item">
              <h4>Support for Divyang Children</h4>
              <p>
                We provide special learning support to children with
                disabilities, helping them access inclusive education and
                opportunities.
              </p>
            </div>
            <div className="grid-item">
              <h4>Universal Secondary Education</h4>
              <p>
                Through collaborations with schools like Punjab Badhir Vidyalya,
                we ensure secondary education reaches every child.
              </p>
            </div>
          </div>
        </section>
        <section className="social-services" data-aos="fade-up">
          <h3>Social Services</h3>
          <p>
            Sarv Sahayata Sangathan (SSS) is committed to serving society
            through various initiatives aimed at uplifting underprivileged and
            vulnerable communities. From promoting education and women's
            empowerment to supporting child rights, health, and disaster relief,
            SSS works holistically to bring sustainable change. Each program is
            driven by compassion, community engagement, and a mission to build a
            better, more inclusive future.
          </p>

          <div className="tabs-container">
            <div className="tab">
              <img src="./Images/educate.png" alt="Education" />
            </div>
            <div className="tab">
              <img src="./Images/gender.png" alt="Women Empowerment" />
            </div>
            <div className="tab">
              <img src="./Images/child.png" alt="Child Rights" />
            </div>
            <div className="tab">
              <img src="./Images/hotel.png" alt="Community Health" />
            </div>
            <div className="tab">
              <img src="./Images/kids.png" alt="Stress Management" />
            </div>
            <div className="tab">
              <img src="./Images/news.png" alt="Blood Donation" />
            </div>
            <div className="tab">
              <img src="./Images/flood.png" alt="Disaster Relief" />
            </div>
            <div className="tab">
              <img src="./Images/women.png" alt="Gau Raksha" />
            </div>
          </div>
        </section>

        {/* Child Rights Section */}
        <section className="section-cards" data-aos="fade-up">
          <h3>👦 Child Rights & Protection</h3>
          <div className="card-container">
            <div className="card">
              <h4>Awareness Campaigns</h4>
              <p>
                We organize regular seminars in schools and communities to
                educate people about Article 21A (child education) and Article
                24 (child labor).
              </p>
            </div>
            <div className="card">
              <h4>Workshops on Child Labor</h4>
              <p>
                We host workshops to eliminate child labor and educate about the
                Right to Education (RTE) Act.
              </p>
            </div>
            <div className="card">
              <h4>Gender Violence & Sanitation Study</h4>
              <p>
                Our studies show the link between gender violence and lack of
                sanitation. We promote policies for safer, hygienic environments
                for girls.
              </p>
            </div>
          </div>
        </section>

        {/* Women Rights Section */}
        <section className="women-rights-slider w-sec" data-aos="fade-up">
          <h3>♀️ Women’s Rights Awareness</h3>
          <Slider {...sliderSettings}>
            <div className="slide">
              <h4>Domestic Violence Act, 2005</h4>
              <p>
                Through our workshops, we help women understand their rights,
                identify abuse, and seek help with support from legal advisors.
              </p>
            </div>
            <div className="slide">
              <h4>Dowry Prohibition & Female Feticide</h4>
              <p>
                Events are organized to raise awareness about women's rights,
                prevention of dowry practices, and female feticide.
              </p>
            </div>
            <div className="slide">
              <h4>Self-Help Groups for Women</h4>
              <p>
                We support women-led SHGs to promote financial literacy,
                micro-entrepreneurship, and economic independence.
              </p>
            </div>
          </Slider>
        </section>

        {/* implemented projects*/}
        <section className="section-cards" data-aos="fade-up">
          <h3>Implemented Projects</h3>
          <div className="card-container">
            <div className="card">
              <h4>Divyang Children Programs</h4>
              <p>
                Differently-abled individuals face various challenges and strive
                to lead meaningful lives. Educational programs have been
                conducted to support Divyang (specially-abled) children in their
                development.
              </p>
            </div>
            <div className="card">
              <h4>Blood Donation Camps</h4>
              <p>
                Due to COVID-19 Blood Donation Camp was organized by Mr. Kapil
                Sharma at PGI, 32 Chandigarh hospital and also in Baddi govt
                hospital. All the preparations such as arrangements of beds,
                sanitation etc were made, a team of doctors and nurses from the
                local govt hospital had reached at time. Mr. Rajendra Arlekar
                (Governor of the Himachal Pradesh) to be the chief guest for
                this function.
              </p>
            </div>
            <div className="card">
              <h4>Self Help Groups</h4>
              <p>
                Women from social economic backward families become important
                stakeholder in livelihood earning of their respective family.
                Sangathan as its key intervention to towards women & youth
                empowerment had has been to organize them in a group. Sangathan
                organising vulnerable women in groups and training them.
              </p>
            </div>
            <div className="card">
              <h4>Cleanliness Campaign and Food supply </h4>
              <p>
                The purpose of this programme was to create awareness among the
                students regarding cleanliness and its benefits. The effect of
                COVID-19 on social economic implications and the impact of
                lockdown on the food supply chain. During COVID-19 Sarv Sahayata
                Sangathan had supplying food to patients and all needy persons
                in PGI.
              </p>
            </div>
            <div className="card">
              <h4>Stress Management programme</h4>
              <p>
                Conducted interactive seminars for students covering the causes,
                effects, and remedies of stress. Activities included treatment,
                rehabilitation, community care, research, training, capacity
                building, awareness, and lobbying. Many students attended the
                seminar, which was conducted in two batches.
              </p>
            </div>
          </div>
        </section>

        {/* Impact Section */}
        <section className="impact" data-aos="zoom-in">
          <h3>🌟 Be a Part of the Movement</h3>
          <p>
            From classrooms to courtrooms, from villages to cities — SSS is
            creating waves of impact. Join us in this mission. Volunteer,
            donate, or amplify our message.
          </p>
          <button className="cta-button">Join Us Today</button>
        </section>
      </div>
      <Foot />
    </>
  );
}
